import styled from "styled-components";
import { OverlayWrapper } from "common/Overlays/Overlay";

const Card = styled.div`
  padding: 16px;
  box-shadow: ${(p) => p.theme.shadows.card};
  background-color: ${(p) => p.theme.colors.cardBgColor};
  width: 100%;
  height: auto;
  border-radius: 12px;
  ${OverlayWrapper} {
    background: ${(p) => p.theme.colors.cardBgColor};
  }
`;

export default Card;
